import {Component, Vue} from 'vue-property-decorator';
import {
  usersIcon,
  settingsIcon,
} from '@deanone/dean-components';

@Component({})
export default class SideMenuPartnerMixin extends Vue {
  public sideMenuRoleSection: any = {
    title: 'Rol',
    items: {
      details: {
        title: 'Gegevens rol',
        icon: settingsIcon,
        name: 'auth.admin.role.edit',
      },
      privileges: {
        title: 'Privileges',
        icon: settingsIcon,
        name: 'auth.admin.role.privileges',
      },
    },
  };

  public buildSideMenuAdmin(title?: string, extraSection?: any) {
    const sideMenu: any = {
      content: {
        title: {
          text: title ? title : 'Auth',
        },
        type: 'themed',
        sections: {
          general: {
            title: 'Authorisatie',
            items: {
              users: {
                title: 'Gebruikers',
                icon: usersIcon,
                name: 'auth.admin.users',
              },
              roles: {
                title: 'Rollen',
                icon: settingsIcon,
                name: 'auth.admin.roles',
              },
            },
          },
        },
      },
    };
    if (extraSection) {
      sideMenu.content.sections.extra = extraSection;
    }

    this.$store.commit('SET_SIDEMENU', sideMenu);
  }
}
